module.exports = __webpack_public_path__ + "assets/betbook-nui-header-894d95.png";